module.exports = __webpack_public_path__ + "static/media/twitter.71cefffb.svg";